// extracted by mini-css-extract-plugin
module.exports = {"review-goods-ifame":"review-goods-ifame-aea1b80342b194679bc32b58e640b9ee","review-iframe":"review-iframe-489429ed4316641bbb2550551fa9f1b6"};